export enum RegionIdMap {
  Taipei = 1,
  Taichung = 3,
  HONG_KONG = 4,
  OKINAWA = 5,
  TAINAN_KAOHSIUNG = 6,
  TOKYO = 8,
  KualaLumpur = 11,
  Bangkok = 13,
  SAPPORO = 14,
  KANSAI = 15,
  PENANG = 16,
  CHIANGMAI = 20,
}

export enum FunnowRegion {
  TAIPEI = 1,
  TAOYUAN = 2,
  TAICHUNG = 3,
  HONG_KONG = 4,
  OKINAWA = 5,
  TAINAN_KAOHSIUNG = 6,
  AMSTERDAM = 7,
  TOKYO = 8,
  TEST = 10,
  KUALA_LUMPUR = 11,
  PENGHU = 12,
  BANGKOK = 13,
  SAPPORO = 14,
  KANSAI = 15,
  PENANG = 16,
  MELAKA = 17,
  LANGKAWI = 18,
  SABAH = 19,
  CHIANGMAI = 20,
}

export enum EdbRegionOnBoard {
  RegionOnBoardOpen = 0,
  RegionOnBoardClose = 1,
}

export interface FregionRegionDetectData {
  country_code?: string
  greetings?: string
  id?: number
  name?: string
  onboard?: EdbRegionOnBoard
}

export interface RegionDetectParams {
  ip: string
  timeZone: string
}
